<template>
    <div id="app" v-if="$route.name == 'login-index' || $route.name == 'reg-index'">
        <router-view :key="key"></router-view>
    </div>
    <div id="app" v-else>
        <div id="top">
            <div class="logo">
                <a target="_blank">{{ cfg.app_name }}</a>
            </div>
            <div class="header_right flex-b">
                <div>
                    <i class="el-icon-s-fold c-fff f-20 p-10" style="cursor: pointer" @click="collapse = !collapse"></i>
                </div>
                <div style="color: #fff">
                    <a target="_blank" :href="cfg.domain">首页</a>
                    <template v-if="is_localhost">
                        {{ vuex_admin.admin_group_id }}
                        <a @click="$vuex('vuex_is_localhost', !vuex_is_localhost)">
                            {{ vuex_is_localhost }}
                        </a>
                    </template>
                </div>
                <div>
                    <el-dropdown @command="_do">
                        <span class="c-fff f-16 ph-20">
                            {{ admin.admin_name }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="3">清理缓存</el-dropdown-item>

                            <el-dropdown-item :command="2">安全退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <div id="bottom">
            <div id="left" :style="{ width: collapse ? '64px' : '220px' }">
                <el-scrollbar style="height: 100%; background-color: #2f4050">
                    <el-menu :collapse="collapse" router unique-opened background-color="#2F4050" text-color="#fff"
                        active-text-color="#fff" :default-active="$route.fullPath">
                        <div v-if="is_localhost">
                            <a @click="_menus">刷新</a>
                            <el-menu-item index="/add_data">
                                <i class="el-icon-menu"></i>
                                <span slot="title">测试</span>
                            </el-menu-item>
                            <el-menu-item index="/table">
                                <i class="el-icon-menu"></i>
                                <span slot="title">数据表</span>
                            </el-menu-item>
                            <el-menu-item index="/fields">
                                <i class="el-icon-menu"></i>
                                <span slot="title">字段</span>
                            </el-menu-item>
                            <el-menu-item index="/menus">
                                <i class="el-icon-menu"></i>
                                <span slot="title">菜单管理</span>
                            </el-menu-item>
                            <el-menu-item index="/admin_rule">
                                <i class="el-icon-menu"></i>
                                <span slot="title">管理权限</span>
                            </el-menu-item>
                            <el-menu-item index="/admin_group">
                                <i class="el-icon-menu"></i>
                                <span slot="title">管理组</span>
                            </el-menu-item>
                            <el-menu-item index="/test">
                                <i class="el-icon-menu"></i>
                                <span slot="title">测试</span>
                            </el-menu-item>
                            <el-menu-item index="/file">
                                <i class="el-icon-menu"></i>
                                <span slot="title">文件</span>
                            </el-menu-item>
                        </div>
                        <el-menu-item :index="`/${item.url}`" v-for="(item, index) in menus" :key="index">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </el-menu-item>
                        <!-- <el-submenu :index="item.id + ''" v-for="(item, index) in menus" :key="index">
                            <template slot="title">
                                <i :class="item.icon"></i>
                                <span>{{ item.title }}</span>
                            </template>
                            <div v-for="(item1, index1) in item.children" :key="index1">
                                <template v-if="(item1.children || []).length">
                                    <el-submenu :index="item1.id + ''">
                                        <span slot="title">{{ item1.title }}</span>
                                        <el-menu-item :index="'/' + item2.url" v-for="(item2, index2) in item1.children"
                                            :key="item2.id">
                                            {{ item2.title }}
                                        </el-menu-item>
                                    </el-submenu>
                                </template>
                                <el-menu-item :index="'/' + item1.url" v-else>
                                    {{ item1.title }}
                                </el-menu-item>
                            </div>
                        </el-submenu> -->
                        <el-menu-item index="/welcome" key="/welcome">
                            <i class="el-icon-edit-outline"></i>
                            <span slot="title">个人资料</span>
                        </el-menu-item>
                    </el-menu>
                </el-scrollbar>
            </div>
            <div id="right">
                <!-- <el-scrollbar style="height: 100%; overflow-x: hidden; width: 100%"> -->
                <router-view :key="key"></router-view>
                <!-- </el-scrollbar> -->
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            menus: [],
            admin: {

            },
            cfg: {},
            collapse: false,


        };
    },
    computed: {
        key() {
            return this.$route.fullPath + new Date();
        },
        is_localhost() {
            let url = window.location.href;
            let res = false;
            if (url.indexOf('127.0.0.1') >= 0 || url.indexOf('localhost') >= 0) {
                res = true;
            }
            return res;
        }
    },
    created() {
        this._menus();
        this._admin({
            append: ['group']
        }).then(res => {
            this.$vuex('vuex_admin', res.data);
        });
        this._config(['app_name', 'domain']);
    },
    mounted() {
        let wh = document.documentElement.clientHeight;
        this.$vuex('vuex_table_h', wh - 180);
        console.log(wh);
    },
    methods: {

        _do(res) {
            switch (res) {

                case 2:
                    this.$vuex('vuex_token', '');
                    this.$vuex('vuex_admin', {});
                    this.$router.push({
                        path: '/login'
                    });
                    break;
                case 3:
                    this.$http.post('index/delcache').then((res) => {
                        location.reload();
                    });
                    break;
            }
        },
        _menus() {
            this.$http
                .post('admin_menus/navs', {
                    order: {
                        id: 'asc'
                    },
                    limit: 100
                })
                .then((res) => {
                    this.menus = res.data;
                });
        }
    }
};
</script>
<style lang="scss">
* {
    margin: 0;
    padding: 0;
}

body .el-table th.gutter {
    display: table-cell !important;
}

@import '@/css/style.scss';
</style>
<style lang="scss" scoped>
@import '@/css/app.scss';
</style>